import { Button, Form, Input, message, Row, Select, Table } from 'antd'
import React from 'react'
import Swal from 'sweetalert2'
import {
  createMasterEventDetail,
  updateMasterEventDetail,
  updateMasterEventDetailSortOrder,
} from '../../api/event.api'

const UpdateEventDetail = ({
  detailInfo,
  setDetailInfo,
  detailForm,
  onAddDetail,
  handleDetailChange,
  styles,
  getEventDetails,
}) => {
  const handleSaveAll = async () => {
    Swal.fire({
      title: '정말 수정하시겠습니까?',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
    }).then((result) => {
      if (result.isConfirmed) {
        handleSaveSortOrder()
        detailInfo.forEach((record) => {
          handleSave(record)
        })
      }
    })
  }
  /**
   * 순서 저장
   */
  const handleSaveSortOrder = async (record) => {
    const getActiveSortedIds = () => {
      return detailInfo
        .filter((item) => item.active === true || item.active === 'true')
        .sort((a, b) => Number(a.sortOrder) - Number(b.sortOrder))
        .map((item) => item.id)
    }

    try {
      const param = getActiveSortedIds()
      const res = await updateMasterEventDetailSortOrder(
        detailInfo[0].masterId,
        param,
      )
    } catch (error) {
      Swal.fire({
        title: '순서 저장 실패\n다시 시도해주세요',
        icon: 'error',
      })
    }
  }

  /**
   * 이벤트 상세 저장
   */
  const handleSave = async (record) => {
    // record에 해당하는 값만 저장
    // 예: await updateMasterEventDetail(record)
    const param = {
      id: record.id,
      snsType: record.snsType,
      title: record.title,
      subTitle: record.subTitle,
      description: record.description,
      link: record.link,
      point: record.point,
    }
    try {
      const res = await updateMasterEventDetail(param)
      if (res.status === 200) {
        message.success('수정되었습니다.')
      }
    } catch (error) {
      console.error(error)
      Swal.fire({
        title: '수정 실패\n다시 시도해주세요',
        icon: 'error',
      })
      return false
    }
  }
  /**
   * 이벤트 추가
   */
  const addDetail = async () => {
    const values = await detailForm.validateFields()
    const res = await createMasterEventDetail({
      ...values,
      masterId: detailInfo[0].masterId,
    })
    if (res.status === 200) {
      Swal.fire({
        title: '추가되었습니다.',
        icon: 'success',
      })
      getEventDetails()
      detailForm.resetFields()
    }
  }
  const detailColumns = [
    {
      title: '순서',
      dataIndex: 'sortOrder',
      key: 'sortOrder',
      width: 60,
      render: (text, record) => (
        <Input
          defaultValue={record.sortOrder}
          onBlur={(e) =>
            handleDetailChange(record.id, 'sortOrder', e.target.value)
          }
        />
      ),
    },
    {
      title: '제목',
      dataIndex: 'title',
      key: 'title',
      render: (text, record) => (
        <Input
          defaultValue={record.title}
          onBlur={(e) => handleDetailChange(record.id, 'title', e.target.value)}
        />
      ),
    },
    {
      title: '서브타이틀',
      dataIndex: 'subTitle',
      key: 'subTitle',
      render: (text, record) => (
        <Input
          defaultValue={record.subTitle}
          onBlur={(e) =>
            handleDetailChange(record.id, 'subTitle', e.target.value)
          }
        />
      ),
    },
    {
      title: '설명',
      dataIndex: 'description',
      key: 'description',
      render: (text, record) => (
        <Input
          defaultValue={record.description}
          onBlur={(e) =>
            handleDetailChange(record.id, 'description', e.target.value)
          }
        />
      ),
    },
    {
      title: '링크',
      dataIndex: 'link',
      key: 'link',
      render: (text, record) => (
        <Input
          defaultValue={record.link}
          onBlur={(e) => handleDetailChange(record.id, 'link', e.target.value)}
        />
      ),
    },
    {
      title: 'SNS 타입',
      dataIndex: 'snsType',
      key: 'snsType',
      render: (text, record) => (
        <Select
          value={record.snsType}
          style={{ width: 120 }}
          onChange={(v) => handleDetailChange(record.id, 'snsType', v)}
        >
          <Select.Option value="INSTA">INSTA</Select.Option>
          <Select.Option value="NAVER">NAVER</Select.Option>
          <Select.Option value="KAKAO">KAKAO</Select.Option>
          <Select.Option value="YOUTUBE">YOUTUBE</Select.Option>
          <Select.Option value="X">X</Select.Option>
          <Select.Option value="THREAD">THREAD</Select.Option>
          <Select.Option value="FACEBOOK">FACEBOOK</Select.Option>
          <Select.Option value="TIKTOK">TIKTOK</Select.Option>
          <Select.Option value="ETC">ETC</Select.Option>
        </Select>
      ),
    },
    {
      title: '포인트',
      dataIndex: 'point',
      key: 'point',
      width: 80,
      render: (text, record) => (
        <Input
          type="number"
          defaultValue={record.point}
          onBlur={(e) => handleDetailChange(record.id, 'point', e.target.value)}
        />
      ),
    },
    {
      title: '활성',
      dataIndex: 'active',
      key: 'active',
      width: 80,
      render: (text, record) => (
        <Select
          value={record.active ? 'true' : 'false'}
          style={{ width: 80 }}
          onChange={(v) => handleDetailChange(record.id, 'active', v)}
        >
          <Select.Option value="true">활성</Select.Option>
          <Select.Option value="false">비활성</Select.Option>
        </Select>
      ),
    },
  ]

  return (
    <div style={{ marginTop: 32 }}>
      <Row
        style={{
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'space-between',
          marginBottom: 32,
        }}
      >
        <div>
          <h3>이벤트 상세 정보</h3>
          <p style={{ color: 'blue', marginTop: 4, fontSize: 12 }}>
            1. 새로 이벤트 정보를 추가할 경우에는 기본적으로 비활성으로
            등록됩니다
            <br />
            2. 이벤트 활성방법은 활성 상태를 "활성"으로 바꾸고 순서를 0부터
            채워주세요
          </p>
        </div>
        <Button type="primary" htmlType="button" onClick={handleSaveAll}>
          저장
        </Button>
      </Row>
      <Form form={detailForm} component={false}>
        <Table
          dataSource={detailInfo}
          rowKey="id"
          bordered
          size="small"
          style={{ marginTop: 24, marginBottom: 24 }}
          pagination={false}
          components={{
            body: {
              cell: ({ children, ...restProps }) => (
                <td {...restProps}>{children}</td>
              ),
            },
          }}
          columns={detailColumns}
        />
      </Form>
      <h3>이벤트 상세 정보 추가</h3>
      <Form
        form={detailForm}
        layout="inline"
        onFinish={addDetail}
        style={{ marginTop: 16, marginBottom: 32 }}
      >
        <Form.Item name="title" rules={[{ required: true, message: '제목' }]}>
          <Input placeholder="제목" />
        </Form.Item>
        <Form.Item name="subTitle">
          <Input placeholder="서브타이틀" />
        </Form.Item>
        <Form.Item name="description">
          <Input placeholder="설명" />
        </Form.Item>
        <Form.Item name="link">
          <Input placeholder="링크" />
        </Form.Item>
        <Form.Item name="point" rules={[{ required: true, message: '포인트' }]}>
          <Input type="number" placeholder="포인트" />
        </Form.Item>
        <Form.Item
          name="snsType"
          rules={[{ required: true, message: 'SNS 타입' }]}
        >
          <Select placeholder="SNS 타입">
            <Select.Option value="INSTA">INSTA</Select.Option>
            <Select.Option value="NAVER">NAVER</Select.Option>
            <Select.Option value="KAKAO">KAKAO</Select.Option>
            <Select.Option value="YOUTUBE">YOUTUBE</Select.Option>
            <Select.Option value="X">X</Select.Option>
            <Select.Option value="THREAD">THREAD</Select.Option>
            <Select.Option value="FACEBOOK">FACEBOOK</Select.Option>
            <Select.Option value="TIKTOK">TIKTOK</Select.Option>
            <Select.Option value="ETC">ETC</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="button" onClick={addDetail}>
            추가
          </Button>
        </Form.Item>
      </Form>
    </div>
  )
}

export default UpdateEventDetail
